import {makeType,actionCreator} from '../../Utils/generateActionCreator';

const actionType = makeType('RECOMMENDED');

export const ADD_RECOMMENDED = actionType('ADD_RECOMMENDED')

export const addRecommended = actionCreator(ADD_RECOMMENDED, 'recommended')